import React from 'react';
import { ModelList } from '../../../fasades/modellist';
import { IModel } from '../../api/llmapi';
import { Util } from '../../../fasades/util';
import './modellist.css';
import './modelselect.css';

type Props = {
    models       : IModel[];
    selected     : IModel | undefined;
};

type State = {
    dropdownOpen : boolean;
}

export class ModelSelect extends React.Component<Props, State> 
{
    constructor(props: Props) {
        super(props);

        this.state = {
            dropdownOpen : false
        }
    }

    async selectModel(chat : IModel)
    {
        this.setState({ dropdownOpen : false });
        ModelList.selectModel(chat);
    };

    toggleDropdown()
    {
        this.setState(prev => ({ dropdownOpen: !prev.dropdownOpen }));
    }

    readerList(models : IModel[]) : React.JSX.Element[]
    {
        return models.map((model : IModel) => (
                <li
                    key={model.name}
                    className={this.props.selected?.name === model.name ? 'selected' : ''}
                    onClick={() => this.selectModel(model)}
                >
                    <div className="list-name">{model.name}</div>
                    <div className="list-desc">{model.description}</div>
                    { (model.parent_model !== undefined) && 
                        <div className="list-time">Last Modified { Util.formatRelativeTime(new Date(model.last_modified)) }</div>
                    }
                </li>
            ));
    }

    render() {
        const models          = Array.isArray(this.props.models) ? this.props.models : [];
        const baseModels      = models.filter(model => model.parent_model === undefined);
        const trainableModels = models.filter(model => model.parent_model !== undefined);

        return (
            <div className="model-combo-box">
                <div className="combo-selected" onClick={ () => this.toggleDropdown () }>
                    <div className="model-info">
                    { !this.props.selected && 'Select a model'}
                    { this.props.selected &&
                        <>
                        <div className="model-name"> {this.props.selected.name}</div>
                        </>
                    }
                    </div>
                    <span className="arrow">{this.state.dropdownOpen ? '▲' : '▼'}</span>
                </div>

                {this.state.dropdownOpen && (
                    <ul className="combo-dropdown">
                        { (baseModels.length > 0) && (
                            <>
                            <div className="model-group">Base Models</div> 
                            { this.readerList(baseModels) }
                            </>
                        )}
                        { (trainableModels.length > 0) && (
                            <>
                            <div className="model-group">Trainable Models</div>
                            { this.readerList(trainableModels) }
                            </>
                        )}
                    </ul>
                )}
            </div>
        );
    }
}

